import passionKitchen from 'brands/passion-kitchen'
import { isProduction } from 'variables/environment'
import { BrandConfigType } from 'types'
import { getBrandDefaultFeatures } from 'brands'

const brand: BrandConfigType = {
  ...passionKitchen,
  liffID: {
    home: isProduction ? '1578956419-K5JolRaX' : '1657129684-nYBEa0dx',
    lineID: isProduction ? '@747djzxj' : '@844gqoba',
  },
  id: isProduction ? 51 : 160,
  categoryEnNameSelected: 'GON Express',
  title: 'GON Express',
  slug: 'gon-express',
  label: 'GON Express',
  labelListScheduledContent: '',
  slogan: 'รสชาติที่คุ้นเคย เสิร์ฟด่วน กินสะดวก',
  brandSelectImg: `${process.env.PUBLIC_URL}/assets/brand/icon-brand-gon-express-optimized.jpeg`,
  checkout: {
    enableRequestTaxInvoice: false,
  },
  features: getBrandDefaultFeatures({ hatostore: { enableETax: true } }),
}

export default brand
